var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var Tag = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 933.45 933.45", width: "1em", height: "1em" }, props),
    React.createElement("defs", null),
    React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
        React.createElement("g", { id: "icon" },
            React.createElement("path", { className: "cls-1", d: "M837.45 0H544a95.38 95.38 0 0 0-67.88 28.12l-448 448a96.1 96.1 0 0 0 0 135.76l210.7 210.75a32 32 0 1 0 45.25-45.26L73.33 566.63a32 32 0 0 1 0-45.26l448-448A31.79 31.79 0 0 1 544 64h293.5a32 32 0 0 1 32 32v293.49a31.78 31.78 0 0 1-9.38 22.63l-448 448a32 32 0 0 1-45.25 0 32 32 0 0 0-45.26 45.25 96.1 96.1 0 0 0 135.77 0l448-448a95.38 95.38 0 0 0 28.12-67.88V96a96.11 96.11 0 0 0-96.05-96z" }),
            React.createElement("path", { className: "cls-1", d: "M773.45 256a96 96 0 1 0-96 96 96.11 96.11 0 0 0 96-96zm-128 0a32 32 0 1 1 32 32 32 32 0 0 1-32-32z" }))))); };
export default Tag;
//# sourceMappingURL=Tag.js.map